import React, { useEffect } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

type Props = {
  className ?: string,
  onClick ?: ((e) => void | Promise<void|boolean>) | ((any) => (any) => void),
  label?: string,
  labelKey?: string,
  children?: React.ReactNode | React.ReactNode[],
  submitting?: boolean,
  disabled?: boolean,
  style?: React.CSSProperties
}

const GButton = (props : Props) => {
  const {
    className = '',
    onClick,
    label,
    labelKey,
    children,
    submitting,
    disabled,
    ...rest
  } = props
  const { t } = useTranslation('common')

  return (
    <button
      disabled={submitting || disabled}
      className={className + (disabled ? ' btn disabled' : '') + (submitting ? ' submitting' : '') + ' tennders-button'}
      onClick={(!disabled && !submitting && onClick) ? (e) => onClick(e) : () => null}
      type="button"
      {...rest}
    >
      {labelKey ? t(labelKey) : (label || children)}
      {submitting && (
        <span className="ml-10">
          <FontAwesomeIcon icon={faSpinner} spin />
        </span>
      )}
    </button>

  )
}

export default GButton
